import {
  BFF_ROUTES,
  UsageProfileResponseSchema,
  type UsageProfileRequest,
  type UsageProfileResponse,
} from '@rheora/enrollment-contract';

import { bffPost } from './bff-client';

/**
 * Typed fetcher for `POST /bff/funnel/usage-profile` (QA-2026-08-05 BLOCKER 1) —
 * record the shopper's chosen home size on their funnel session.
 *
 * Thin by design: build the path, validate against the shared contract schema,
 * return. Pages/components call the `usage-profile.queries` hook, never this.
 *
 * ── WHAT TRAVELS ───────────────────────────────────────────────────────────
 * A size TOKEN (`small | medium | large`), never a kWh figure. The BFF owns the
 * size → representative-usage mapping, so the browser cannot choose the usage
 * basis a regulated §25.478 deposit is derived from. Credential-free like every
 * storefront call: no Authorization, no x-tenant-id — `bffPost` adds the
 * Idempotency-Key and correlation id the public POST floor requires.
 */
export async function postUsageProfile(
  request: UsageProfileRequest,
): Promise<UsageProfileResponse> {
  return bffPost(BFF_ROUTES.usageProfile, request, UsageProfileResponseSchema);
}
